import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Button, Form, Input} from 'reactstrap';
import {I18n} from '../../I18n/components/companyMarket';
import {PAGINATION_DEFAULT_LIMIT, VIEWS} from '../../helpers/constants';
import {push} from 'connected-react-router';
import {changeUpdatesStatus, fetchNewAlertNotifications} from "../../actions/alertActions";

const MarketControls = props => {

    const { lang, newAlertsTotal } = props;
    return (
        <div className="localmarket-subtitle">
            <section className="localmarket-subtitle__main">
                <Form className="localmarket__searchform">
                    <Input
                        className="localmarket__search"
                        type="text"
                        name="search"
                        id="search"
                        placeholder={I18n[lang].searchPlaceholder}
                        value={props.appNameFilterWord}
                        onChange={e => props.filterAppByNameHandler(e.target.value)}
                    />
                    <Input
                        className="localmarket__filter"
                        type="select"
                        name="view-filter"
                        id="view-filter"
                        onChange={props.changeGlobalView}
                        value={props.globalView}
                    >
                        <option value="">{I18n[lang].selectView}</option>
                        <option value={VIEWS.PACKAGE_AND_APP}>{I18n[lang].view_packAndApp}</option>
                        <option value={VIEWS.PACKAGE_ONLY}>{I18n[lang].view_pack}</option>
                        <option value={VIEWS.APP_ONLY}>{I18n[lang].view_app}</option>
                        <option value={VIEWS.UPDATES_ONLY}>{I18n[lang].view_updates}</option>
                    </Input>
                </Form>
            </section>
            <section className="localmarket-title__buttons">
                <button
                    className="localmarket-title__market-btn btn btn btn-secondary btn-md"
                    onClick={props.uploadApk}
                >
                    {I18n[lang].uploadApk}
                </button>
                <button
                    className="localmarket-title__market-btn btn btn btn-secondary btn-sm"
                    onClick={props.packageManagerToggle}
                >
                    {I18n[lang].appManager}
                </button>
                <button
                    className="localmarket-title__market-btn btn btn btn-secondary btn-sm"
                    onClick={() => props.changeLocation('/dashboard/market')}
                >
                    {I18n[lang].market}
                </button>
                <button
                    className="localmarket-title__market-btn btn btn btn-secondary btn-sm"
                    onClick={props.createPackageModalToggle}
                >
                    {I18n[lang].addPackage}
                </button>
                {
                    newAlertsTotal !== 0 ? <button
                                className="localmarket-title__market-btn btn btn btn-secondary btn-sm"
                                onClick={props.confirmAllHandler}
                            >
                                {I18n[lang].updateAll} ({newAlertsTotal})
                            </button> : null
                }
            </section>
        </div>
    )
};

export default MarketControls;



// WEBPACK FOOTER //
// ./src/components/CompanyMarket/MarketControls.js